import * as Sentry from '@sentry/react';
import React from 'react';
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router-dom';
import { getSentrySettings, PRODUCTION } from '@web/common';
import { browserTracingIntegration } from '@sentry/react';

export function setupSentry() {
  const hostUrl = window.location.origin;
  const sentryDsn = process.env['NX_SENTRY_DSN_FRONTEND'];
  const isDev = hostUrl.includes('localhost');
  const forceEnable = process.env['NX_SENTRY_FORCE_ENABLE'] === 'true';

  // Skip local dev unless explicitly forced (e.g. for testing distributed tracing locally).
  if (isDev && !forceEnable) return;

  const environment = process.env['NX_ENVIRONMENT'] ?? '';
  const apiHost = process.env['NX_API_HOST'];

  console.debug('initializing Sentry...');
  Sentry.init({
    dsn: sentryDsn,
    environment,
    release: process.env['NX_REVISION'],
    integrations: [
      // See docs for support of different versions of variation of react router
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
      browserTracingIntegration(),
    ],

    // Propagate sentry-trace and baggage headers to the backend API so that
    // frontend and backend events are linked into a single distributed trace.
    tracePropagationTargets: [/^\/api\//, ...(apiHost ? [apiHost] : [])],

    ...getSentrySettings(environment),

    replaysSessionSampleRate: environment === PRODUCTION ? 0.05 : 1.0,
    replaysOnErrorSampleRate: environment === PRODUCTION ? 0.5 : 1.0,
  });
}
